import { Formik } from "formik";
import React from "react";
import { HotelSearchForm } from "./HotelSearchForm";
import { useSearchHotels } from "../../hooks/useSearchHotels";

export const HotelSearchFormik = ({
  searchUpdate=false,
  showRoomInfoModal,
  setShowRoomInfoModal,
  queryparams,
  showTitle = false,
  hotelsList = [],
  header={}
}) => {
  const {
    initialValues,
    formSchema,
    onSearch,
    formRef,
    staticData,
    countries,
    personError,
    setPersonError, sameDateError, setSameDateError
  } = useSearchHotels(queryparams, searchUpdate);

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={formSchema}
      onSubmit={(values) => {
        onSearch(values);
      }}
    >
      {({ values, setFieldValue, setFieldTouched, handleSubmit, errors, touched, submitCount }) => {
        return (
          <div className="hw-input--groupCol">
            {showTitle ? <h2 class="grid-span2 mb-0">Book A Hotel</h2> : null}
            <HotelSearchForm
              values={values}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              errors={errors}
              touched={touched}
              submitCount={submitCount}
              setShowRoomInfoModal={setShowRoomInfoModal}
              staticData={staticData}
              showRoomInfoModal={showRoomInfoModal}
              handleSubmit={handleSubmit}
              countries={countries}
              searchUpdate={searchUpdate}
              hotelsList={hotelsList}
              personError={personError}
              setPersonError={setPersonError}
              setSameDateError={setSameDateError}
              sameDateError={sameDateError}
              header={header}
            />
          </div>
        );
      }}
    </Formik>
  );
};